__turbopack_context__.v({
  "ebBackgroundGlow": "ElectricBorder-module__m2yVwa__ebBackgroundGlow",
  "ebCanvas": "ElectricBorder-module__m2yVwa__ebCanvas",
  "ebCanvasContainer": "ElectricBorder-module__m2yVwa__ebCanvasContainer",
  "ebContent": "ElectricBorder-module__m2yVwa__ebContent",
  "ebGlow1": "ElectricBorder-module__m2yVwa__ebGlow1",
  "ebGlow2": "ElectricBorder-module__m2yVwa__ebGlow2",
  "ebLayers": "ElectricBorder-module__m2yVwa__ebLayers",
  "electricBorder": "ElectricBorder-module__m2yVwa__electricBorder",
  "root": "ElectricBorder-module__m2yVwa__root",
});
